/**
 * Colour dropdown support for a non-standard ("Others") colour. The custom
 * value is stored in the line's existing `colour` string; a colour that is
 * non-empty and not one of the product's presets is treated as a custom entry,
 * so the editor re-opens in "Others" mode when a saved quote is reloaded.
 */
export const OTHER_COLOUR = '__OTHER__';

export function isCustomColour(colour: string | undefined, presets: string[] | undefined): boolean {
  const c = (colour ?? '').trim();
  if (!c) return false;
  return !(presets ?? []).includes(c);
}
